module.exports = __webpack_public_path__ + "img/circulationIcon.0bdf037c.png";